import { HttpEvent } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Defect } from "src/app/models/defect.model";
import { QueryStrings } from "src/app/models/emitter-events.models";
import { RequestService } from "src/app/services/request/request.service";

@Injectable({
	providedIn: "root",
})
export class DefectListService {
	private httpOptions = {
		observe: "response",
	};

	constructor(public requestService: RequestService) {}

	public getDefectList(companyId: string, query: QueryStrings, endpoint: string): Observable<HttpEvent<Defect[]>> {
		const { sort, sortDir, page, perPage, ...remainingQueryStrings } = query;
		const url = `${endpoint}/defects?page=${page}&perPage=${perPage}&sort=${sort}&sortDir=${sortDir}`;
		const data = { companyId, ...remainingQueryStrings };

		return this.requestService.post<HttpEvent<Defect[]>>({ url, data, httpOptions: this.httpOptions });
	}
}
